document.addEventListener('DOMContentLoaded', main)

function debounce (func, wait) {
  let timeout

  return function executedFunction () {
    clearTimeout(timeout)
    timeout = setTimeout(_ => {
      timeout = null
      func.apply(this, arguments)
    }, wait)
  }
}

function runFilter (keydownEvent) {
  if (keydownEvent.key === 'Escape') {
    return clear()
  }
  filter(keydownEvent.target.value.toLocaleLowerCase())
}

function filter (filter) {
  document.querySelectorAll('table tr.event').forEach(tr => (tr.style.display =
    [...tr.children].some(td => td.textContent.toLocaleLowerCase().includes(filter)) ? 'table-row' : 'none'
  ))
  document.querySelectorAll('table tr:not(.event):not(:first-child)').forEach(tr => (
    tr.style.display = hasVisibileEvents(tr) ? 'table-row' : 'none'
  ))
  requestHeightChange(document.querySelector('.rte_wrapper').scrollHeight)
}

function hasVisibileEvents (tr) {
  tr = tr.nextElementSibling
  while (tr && tr.classList.contains('event')) {
    if (tr.style.display !== 'none') {
      return true
    }
    tr = tr.nextElementSibling
  }
  return false
}

function requestHeightChange (height) {
  window.parent.postMessage({
    fn: 'iframe',
    args: {
      name: window.name,
      height: height
    }
  },
  '*'
  )
}

function clear () {
  document.querySelector('.search_form_wrapper input').value = ''
  filter('')
}

function main () {
  document.querySelector('.search_form_wrapper input').addEventListener('keydown', debounce(runFilter, 100))
  document.querySelector('.search_form_wrapper button').addEventListener('click', clear)
  window.requestAnimationFrame(_ => requestHeightChange(document.querySelector('.rte_wrapper').scrollHeight))
}
